export enum LoginScope {
  ADMIN = 'Admin',
  CLIENT = 'Client',
}

export enum ProfileStatus {
  Inactive,
  Active,
}

export enum FaceIdRegistrationStatus {
  Pending,
  Registered,
}

export enum ProfileType {
  Employee,
  Guest,
  Root,
}
